import {
  LayoutDashboard,
  Building2,
  Droplet,
  Users,
  UserCog,
  Building,
  Wrench,
  KeyRound,
  Wallet,
  FileText,
  Receipt,
  MessageSquare,
  Home,
  ClipboardList,
  UserPlus,
  Clock,
  ShieldCheck,
} from 'lucide-react';

// Mirrors the existing activePage keys in each dashboard exactly — this file
// only controls how the sidebar groups/labels/icons them, not routing.
export const adminNav = [
  {
    group: 'Overview',
    items: [{ key: 'dashboard', label: 'Dashboard', icon: LayoutDashboard }],
  },
  {
    group: 'Property',
    items: [
      { key: 'units', label: 'Units', icon: Building2 },
      { key: 'water', label: 'Water Bills', icon: Droplet },
    ],
  },
  {
    group: 'People',
    items: [
      { key: 'tenants', label: 'Tenants', icon: Users },
      { key: 'add-tenant', label: 'Add Tenant', icon: UserPlus },
      { key: 'agents', label: 'Agents', icon: UserCog },
      { key: 'landlords', label: 'Landlords', icon: Building },
      { key: 'admins', label: 'Admins', icon: ShieldCheck },
      { key: 'caretakers', label: 'Caretakers', icon: Wrench },
      { key: 'reset-requests', label: 'Password Resets', icon: KeyRound },
    ],
  },
  {
    group: 'Finance',
    items: [
      { key: 'payments', label: 'Payments', icon: Wallet },
      { key: 'invoices', label: 'Invoices', icon: FileText },
      { key: 'expenses', label: 'Expenses', icon: Receipt },
      { key: 'reports', label: 'Reports', icon: ClipboardList },
    ],
  },
  {
    group: 'System',
    items: [
      { key: 'messages', label: 'Messages', icon: MessageSquare },
      { key: 'my-profile', label: 'My Profile', icon: UserCog },
    ],
  },
];

// Tenants get one page — fewer nav items, mobile-first, per spec.
export const tenantNav = [
  {
    group: 'My Account',
    items: [{ key: 'dashboard', label: 'Dashboard', icon: Home }],
  },
];

// Matches agent/Dashboard.jsx's real activePage keys exactly — 'dashboard'
// is the one new tab this redesign adds as the landing overview.
export const agentNav = [
  {
    group: 'Overview',
    items: [{ key: 'dashboard', label: 'Dashboard', icon: LayoutDashboard }],
  },
  {
    group: 'People',
    items: [
      { key: 'tenants', label: 'Tenants', icon: Users },
      { key: 'pending', label: 'Pending', icon: Clock },
      { key: 'add', label: 'Add Tenant', icon: UserPlus },
      { key: 'reset-requests', label: 'Password Resets', icon: KeyRound },
    ],
  },
  {
    group: 'Property',
    items: [
      { key: 'caretakers', label: 'Caretakers', icon: Wrench },
      { key: 'water', label: 'Water Bills', icon: Droplet },
    ],
  },
  {
    group: 'Finance',
    items: [
      { key: 'payments', label: 'Payments', icon: Wallet },
      { key: 'expenses', label: 'Expenses', icon: Receipt },
      { key: 'reports', label: 'Reports', icon: ClipboardList },
    ],
  },
];

// Matches landlord/Dashboard.jsx's real activePage keys exactly.
export const landlordNav = [
  {
    group: 'Overview',
    items: [{ key: 'dashboard', label: 'Dashboard', icon: LayoutDashboard }],
  },
  {
    group: 'Property',
    items: [
      { key: 'properties', label: 'Property', icon: Building2 },
      { key: 'agents', label: 'Agents', icon: UserCog },
      { key: 'caretakers', label: 'Caretakers', icon: Wrench },
      { key: 'water', label: 'Water Bills', icon: Droplet },
    ],
  },
  {
    group: 'Finance',
    items: [{ key: 'payments', label: 'Payments', icon: Wallet }],
  },
  {
    group: 'System',
    items: [{ key: 'reports', label: 'Reports', icon: ClipboardList }],
  },
];
